export { default as registerFormDefault } from "./register_form_default";
